import { render } from "./Side_bar.vue?vue&type=template&id=bd30c5c8"
import script from "./Side_bar.vue?vue&type=script&lang=js"
export * from "./Side_bar.vue?vue&type=script&lang=js"

import "./Side_bar.vue?vue&type=style&index=0&id=bd30c5c8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__